import type { AdditionOption, ExceptionOption } from '../types/@types/product';

export function buildKitchenSummary(params: {
  flavorsNames?: string[];
  additions?: Record<string, number>;
  additionsCatalog?: AdditionOption[];
  exceptions?: string[];
  exceptionsCatalog?: ExceptionOption[];
}) {
  const pieces: string[] = [];

  if (params.flavorsNames && params.flavorsNames.length) {
    pieces.push(`Sabores: ${params.flavorsNames.join(', ')}`);
  }
  if (params.additions && params.additionsCatalog?.length) {
    const map = new Map(
      params.additionsCatalog.filter(o => o.active).map(o => [o.key, o]),
    );
    const adds: string[] = [];
    for (const [key, qty] of Object.entries(params.additions)) {
      if (!qty) continue;
      const opt = map.get(key);
      if (opt) adds.push(`+ ${opt.name} x${qty}`);
    }
    if (adds.length) pieces.push(adds.join(' | '));
  }
  if (params.exceptions && params.exceptionsCatalog?.length) {
    const map = new Map(
      params.exceptionsCatalog.filter(o => o.active).map(o => [o.key, o]),
    );
    const excs: string[] = [];
    for (const key of params.exceptions) {
      const opt = map.get(key);
      if (opt) excs.push(`– ${opt.name}`);
    }
    if (excs.length) pieces.push(excs.join(' | '));
  }

  return pieces.join('  •  ');
}
